import React from 'react';
import * as S from './WhatOurGuestLikeLoader.styles';

const WhatOurGuestLikeLoader = () => {
  return (
    <S.WhatOurGuestLikeLoader>
      <S.WhatOurGuestLikeSmallWrap></S.WhatOurGuestLikeSmallWrap>
      <S.WhatOurGuestLikeSmallWrap></S.WhatOurGuestLikeSmallWrap>
      <S.WhatOurGuestLikeLargeWrap></S.WhatOurGuestLikeLargeWrap>
      <S.WhatOurGuestLikeMediumWrap></S.WhatOurGuestLikeMediumWrap>
      <S.WhatOurGuestLikeSmallWrap></S.WhatOurGuestLikeSmallWrap>
      <S.WhatOurGuestLikeSmallWrap></S.WhatOurGuestLikeSmallWrap>

      <S.WhatOurGuestLikeInnerLoader>
        <S.WhatOurGuestLikeSmallWrap></S.WhatOurGuestLikeSmallWrap>
        <S.WhatOurGuestLikeLargeWrap></S.WhatOurGuestLikeLargeWrap>
        <S.WhatOurGuestLikeMediumWrap></S.WhatOurGuestLikeMediumWrap>
        <S.WhatOurGuestLikeSmallWrap></S.WhatOurGuestLikeSmallWrap>
        <S.WhatOurGuestLikeSmallWrap></S.WhatOurGuestLikeSmallWrap>
      </S.WhatOurGuestLikeInnerLoader>
    </S.WhatOurGuestLikeLoader>
  );
};

export default WhatOurGuestLikeLoader;
